import { IBasicRightResults } from "../../../UI/UI/Rights/BasicRightsResults";
import { IAsyncTree, IBaseAsyncTreeVisitorResult } from "../DataTypes/IAsyncTree";
import { IItemRightsCollection } from "./RightTypes";

/**
 * Obecný interface stromu komponent používaného pro vyhodnocování práv nebo validnosti
 */
export interface IComponentTree<TComponent, TComponentType> extends IAsyncTree<TComponent> {
    /**
     * Nadřízený uzel stromu
     */
    readonly parentNode: IComponentTree<TComponent, TComponentType> | null;

    /**
     * Komponenta stromu
     */
    readonly component: TComponent;

    /**
     * Název atributu komponenty
     */
    readonly attrName: string;
    /**
     * Typ komponenty (atribut/metoda)
     */
    readonly componentType: TComponentType | null;
    /**
     * Podmínka komponenty
     */
    readonly condition: string;
    /**
     * Kolekce práv na komponentě
     */
    readonly componentRightsCollection: IItemRightsCollection;
    /**
     * Pokud jde o statickou komponentu
     */
    readonly isStatic: boolean | null;

    /**
     * Příznak, že byl uzel stromu zatím pouze před-inicializován
     */
    isPreinitializedOnly?: boolean;
}

/**
 * @generateInstanceClass
 */
export interface IComponentTreeVisitorResult extends IBaseAsyncTreeVisitorResult {
    visible?: boolean;
    basicRightResults?: IBasicRightResults;
}

export class IComponentTreeVisitorResult {
    private static _properties: (keyof IComponentTreeVisitorResult)[] = ["visible", "basicRightResults"];

    public static [Symbol.hasInstance](instance: any): boolean {
        // POZOR! Nestandardní definice. Protože má interface jen nepovinné property, nemůžeme je kontrolovat povinně. Aby to zase nebyla jen úplně obecná kontrola, jestli je to objekt bez dalších specifik,
        // tak se kontroluje, že pokud má nějaké property, tak by měl obsahovat alespoň některou z nepovinných. Pokud nemá žádné property, kontrolou projde.
        return instance != null && (Reflect.ownKeys(instance).length === 0 || this._properties.some(propertyKey => Reflect.has(instance, propertyKey))) && instance instanceof IBaseAsyncTreeVisitorResult;
    }
}

export interface IComponentTreeVisitorVisibleResult extends IComponentTreeVisitorResult {
    visible: boolean;
}

export class IComponentTreeVisitorVisibleResult {
    private static _properties: (keyof IComponentTreeVisitorVisibleResult)[] = ["visible"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some(property => !Reflect.has(instance, property));
    }
}

export interface IComponentTreeVisitorBasicRightResult extends IComponentTreeVisitorResult {
    basicRightResults: IBasicRightResults;
}

export class IComponentTreeVisitorBasicRightResult {
    private static _properties: (keyof IComponentTreeVisitorBasicRightResult)[] = ["basicRightResults"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some(property => !Reflect.has(instance, property));
    }
}
